module.exports = __webpack_public_path__ + "static/media/toast.8dc1f71d.jpg";